import { render } from "./Wheel7.vue?vue&type=template&id=02404b6a"
const script = {}
script.render = render

export default script